import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgChevrondown } from '@common/icon';
import { cn } from '@core/utils';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
export const InfiniteListMoreButton = t0 => {
  const $ = _c(7);
  const {
    onClick,
    className
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  let t1;
  if ($[0] !== className) {
    t1 = cn("w-full max-w-[480px]", "mobile-tablet:max-w-full", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isDesktopViewport ? "H56" : "H40";
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SvgChevrondown className="size-16 text-Gray-600" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onClick || $[4] !== t1 || $[5] !== t2) {
    t4 = <Button className={t1} theme="sub-line" onClick={onClick} dimensions={t2}>더보기{t3}</Button>;
    $[3] = onClick;
    $[4] = t1;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};